<template lang="pug">
div
  .topo
    img#logo(
      src='@/assets/images/logo.png',
      alt='sicarf',
      name="logo"
      @click="goHome"
    )
    .user(v-if="!$route.meta.isPublic")
      .usuario
        i.fas.fa-user-circle
        .descricao
          span &nbsp {{ truncate(nomeUsuario, 25, '...') }}
          span.nomePerfil(v-if="nomePerfil") &nbsp {{ nomePerfil }}
      .logout
        app-action-button(
          icone="sign-out-alt",
          @click="sair",
          cor="#a7b2bb",
          text="Sair",
          fontSize="25"
        )
</template>

<script>
import AppActionButton from "@/components/AppActionButton";
import { mapActions, mapGetters } from "vuex";

export default {
  components: {
    AppActionButton
  },

  computed: {
    ...mapGetters({
      usuario: "auth/usuarioLogado"
    }),

    nomeUsuario() {
      if (!this.usuario) {
        return "-";
      }

      return this.usuario.nome;
    },

    nomePerfil() {
      if (!this.usuario) {
        return "-";
      }

      return this.usuario.perfilSelecionado
        ? this.usuario.perfilSelecionado.nome
        : null;
    }
  },

  methods: {
    ...mapActions({
      clearPerfil: "auth/clearPerfil",
      logout: 'auth/logout'
    }),

    async sair() {
      this.logout();
      window.location.href = 'https://' + (process.env.NODE_ENV === 'development' ?  window.location.hostname + ':8081' : window.location.hostname) + '/agedoce/#/login';
    },

    goHome() {
      this.$router.push({
        name: this.usuario.perfilSelecionado
          ? this.usuario.perfilSelecionado.paginaInicial
          : "selecionarModulo"
      });
    },

    truncate(str, length, ending) {
      if (length == null) {
        length = 100;
      }
      if (ending == null) {
        ending = "...";
      }
      if (str && str.length > length) {
        return str.substring(0, length - ending.length) + ending;
      } else {
        return str;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/style/_variables.scss";

.topo {
  width: 100%;
  height: $header-size;
  display: flex;
  align-items: center;
  padding: 0 5% 0 5%;
  justify-content: space-between;
  background-color: #f3f7fa;
  font-size: xx-large;
  border-bottom: solid 1px #eaeef1;

  .light {
    color: $lightgray-color;
  }

  span {
    font-size: 15px;
    color: #424242;
  }

  #logo {
    height: 100%;
    width: auto;
    cursor: pointer;
  }

  .user {
    display: flex;
    align-items: center;
    color: #a7b2bb;
    justify-content: space-between;

    .usuario {
      display: flex;
      align-items: center;
      .descricao {
        text-align: left;
        display: flex;
        flex-direction: column;
        .nomePerfil {
          opacity: 0.8;
        }
      }
    }
    .logout {
      margin-left: 1vw;
      display: flex;
      align-items: center;
      font-size: 15px;
      .icon {
        font-size: inherit !important;
      }
    }
  }
}
</style>
